<template>
    <div>
        <education-plans-grid
                :items="items"
                :total="total"
                :loading="loading"
                @paginate="onPaginate"
                @editItem="editItem"
                @deleteItem="deleteItem"
        >
        </education-plans-grid>

        <v-dialog fullscreen 
                  persistent
                  content-class="educational-plan-full-screen" 
                  transition="dialog-bottom-transition" v-model="dialog" hide-overlay>
            <v-card>
                <add-edit-education-plan
                        v-if="dialog"
                        @shouldCloseAddEdit="dialog = false"
                        @addedEdited="addedEdited"
                        :edit-mode="editMode"
                        :edit-id="editId"
                ></add-edit-education-plan>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRemove" max-width="290">
            <delete-confirm
                    @shouldCloseDeleteConfirm="dialogRemove = false"
                    @removed="removed"
                    :delete-id="deleteId"
            >
            </delete-confirm>
        </v-dialog>

        <v-btn
                color="primary"
                dark
                fixed
                bottom
                right
                fab
                @click="addItem()"
        >
            <v-icon>add</v-icon>
        </v-btn>
    </div>
</template>
<script>
    import HttpService from "../../../../HttpService";
    import EducationPlansGrid from "./EducationPlansGrid";
    import {objectQueryStringify} from "../../../../helpers/querystringHelper";
    import AddEditEducationPlan from "./AddEditEducationPlan";
    import DeleteConfirm from "./DeleteConfirm";

    export default {
        components: {
            EducationPlansGrid,
            AddEditEducationPlan,
            DeleteConfirm
        },
        methods: {
            getItems(queryParams) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`educationPlan?${queryParams}`)
                    .then(subjects => {
                        this.items = subjects.items;
                        this.total = subjects.total;
                        this.loading = false;
                    })
            },
            onPaginate(paginationData) {
                if (this.items.length === 0 || 
                    JSON.stringify(this.pagination) !== JSON.stringify(paginationData)) {
                    this.pagination = Object.assign(this.pagination, paginationData);

                    this.getItems(objectQueryStringify(this.pagination));
                }
            },
            addItem() {
                this.dialog = true;
                this.editId = null;
                this.editMode = false;
            },
            editItem(itemId) {
                this.dialog = true;
                this.editId = itemId;
                this.editMode = true;
            },
            addedEdited() {
                this.dialog = false;
                this.editId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
            deleteItem(itemId) {
                this.dialogRemove = true;
                this.deleteId = itemId;
            },
            removed() {
                this.dialogRemove = false;
                this.deleteId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
        },
        data: () => {
            return {
                dialog: false,
                dialogRemove: false,
                editId: null,
                editMode: false,
                deleteId: null,
                items: [],
                total: null,
                loading: false,
                pagination: {
                    totalItems: 0,
                },
            }
        }
    }
</script>
<style lang="scss">
    .educational-plan-full-screen {
        overflow-y: unset !important;
    }
</style>